import useSWR from 'swr';
import * as Sentry from '@sentry/nextjs';
import type {
  CalendlyAvailableTimes,
  CalendlyEventUris,
} from '../lib/calendly';
import { swrFetcher } from '../lib/swrFetcher';

export const useUpdateCalendlyAvailability = ({
  schedulingUrls,
  calendlyEventUris,
  calendlyAvailableTimesFallback,
}: {
  schedulingUrls: string[];
  calendlyEventUris: CalendlyEventUris;
  calendlyAvailableTimesFallback: CalendlyAvailableTimes;
}) => {
  const { data: calendlyAvailableTimes } = useSWR<CalendlyAvailableTimes>(
    {
      method: 'POST',
      url: '/api/calendly',
      body: {
        schedulingUrls,
        calendlyEventUris,
      },
    },
    swrFetcher,
    {
      fallbackData: calendlyAvailableTimesFallback,
      revalidateOnMount: true,
      onError: (error) =>
        Sentry.captureException(
          new Error('Error updating Calendly availability'),
          { extra: { error } },
        ),
    },
  );
  return { calendlyAvailableTimes };
};
